const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CargoManagementCommand: any = {
    UpdateCargoLimit: `${Backofficebff}/v1/cargomanagement/updatecargoorderlimit`,
    UpdateCargoCompanyPriorityCity: `${Backofficebff}/v1/cargomanagement/updatecargocompanyprioritycity`,
    DeleteCargoCompanyPriorityCity: `${Backofficebff}/v1/cargomanagement/deletecargocompanyprioritycity`,
    SendDeliveryList: `${Backofficebff}/v1/cargomanagement/senddeliverylist`,
};
